<template>
  <q-menu
    v-model="model"
    class="menu-standard"
    :target="target"
    :no-parent-event="noParentEvent"
    :context-menu="contextMenu"
    :dark="dark"
    :transition-show="transitionShow"
    :transition-hide="transitionHide"
    :transition-duration="transitionDuration"
    :persistent="persistent"
    :auto-close="autoClose"
    :separate-close-popup="separateClosePopup"
    :no-esc-dismiss="noEscDismiss"
    :no-route-dismiss="noRouteDismiss"
    :no-refocus="noRefocus"
    :no-focus="noFocus"
    :fit="fit"
    :cover="cover"
    :square="square"
    :anchor="anchor"
    :self="self"
    :offset="offset"
    :scroll-target="scrollTarget"
    :touch-position="touchPosition"
    :max-height="maxHeight"
    :max-width="maxWidth"
  >
    <template
      v-for="(slot, slotName) in $slots"
      #[slotName]="scope"
      :key="slotName"
    >
      <slot
        :name="slotName"
        v-bind="scope || {}"
      />
    </template>
  </q-menu>
</template>

<script setup>
defineOptions({ name: 'Menu' })
const model = defineModel({ type: Boolean, default: false })
const props = defineProps({
  target: { type: [Boolean, String, Element], default: true },
  noParentEvent: { type: Boolean, default: null },
  contextMenu: { type: Boolean, default: null },
  modelValue: { type: Boolean, default: false },
  dark: { type: Boolean, default: null },
  transitionShow: { type: String, default: 'fade' },
  transitionHide: { type: String, default: 'fade' },
  transitionDuration: { type: [String, Number], default: 300 },
  persistent: { type: Boolean, default: false },
  autoClose: { type: Boolean, default: false },
  separateClosePopup: { type: Boolean, default: false },
  noEscDismiss: { type: Boolean, default: false },
  noRouteDismiss: { type: Boolean, default: false },
  noRefocus: { type: Boolean, default: false },
  noFocus: { type: Boolean, default: false },
  fit: { type: Boolean, default: false },
  cover: { type: Boolean, default: false },
  square: { type: Boolean, default: false },
  anchor: {
    type: String,
    default: 'bottom middle',
    validator: v => [
      'top left',
      'top middle',
      'top right',
      'top start',
      'top end',
      'center left',
      'center middle',
      'center right',
      'center start',
      'center end',
      'bottom left',
      'bottom middle',
      'bottom right',
      'bottom start',
      'bottom end'
    ].includes(v) },
  self: {
    type: String,
    default: 'top middle',
    validator: v => [
      'top left',
      'top middle',
      'top right',
      'top start',
      'top end',
      'center left',
      'center middle',
      'center right',
      'center start',
      'center end',
      'bottom left',
      'bottom middle',
      'bottom right',
      'bottom start',
      'bottom end'
    ].includes(v) },
  offset: { type: Array, default: () => [0, 4] },
  scrollTarget: { type: [Element, String], defaul: null },
  touchPosition: { type: Boolean, default: false },
  maxHeight: { type: String, default: null },
  maxWidth: { type: String, default: null }
})

</script>

<style>
@reference "#app-styles.css";

.menu-standard {
  @apply surface-float shadow-lg rounded-lg;
}
</style>
